var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"pointer",attrs:{"src":require("@/assets/img/main/logo.svg"),"alt":"logo"}})]),_c('div',[_vm._v(_vm._s("title"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }